import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40481b1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal is-active",
  tabindex: "0"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = { class: "modal-card-body" }
const _hoisted_7 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = {
  key: 1,
  class: "modal-card"
}
const _hoisted_15 = { class: "modal-card-head" }
const _hoisted_16 = { class: "is-flex is-flex-shrink-0" }
const _hoisted_17 = { class: "icon has-text-white" }
const _hoisted_18 = { class: "modal-card-title is-title-shrink" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot is-justify-content-flex-end" }, null, -1))
const _hoisted_20 = {
  key: 2,
  class: "modal-card"
}
const _hoisted_21 = { class: "modal-card-head" }
const _hoisted_22 = { class: "is-flex is-flex-shrink-0" }
const _hoisted_23 = { class: "icon has-text-white" }
const _hoisted_24 = { class: "modal-card-title is-title-shrink" }
const _hoisted_25 = { class: "modal-card-body" }
const _hoisted_26 = { class: "body-content is-size-4" }
const _hoisted_27 = { class: "status-icon-container mb-3" }
const _hoisted_28 = { class: "status-label draft mb-2" }
const _hoisted_29 = { class: "amount has-text-weight-bold is-size-3 mb-3" }
const _hoisted_30 = { class: "currency" }
const _hoisted_31 = {
  key: 0,
  class: "message-text mb-3"
}
const _hoisted_32 = { class: "parties mb-3" }
const _hoisted_33 = { class: "frame3-sub-title" }
const _hoisted_34 = { class: "party-name has-text-weight-bold is-size-5" }
const _hoisted_35 = { class: "frame3-sub-title mt-2" }
const _hoisted_36 = { class: "party-name has-text-weight-bold is-size-5" }
const _hoisted_37 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-center" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoneyTransaction = _resolveComponent("MoneyTransaction")!
  const _component_RecurrenceOptions = _resolveComponent("RecurrenceOptions")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_RecipientSelector = _resolveComponent("RecipientSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$modal.step.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$gettext("Request money")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createVNode(_component_MoneyTransaction, {
              directionTransfer: "receive",
              account: _ctx.account,
              selectedRecipient: null,
              config: _ctx.form,
              transactionType: "createRequestPay",
              "onUpdate:amount": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.amount = $event)),
              "onUpdate:senderMemo": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.senderMemo = $event)),
              "onUpdate:recipientMemo": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.recipientMemo = $event)),
              "onUpdate:isValid": _cache[4] || (_cache[4] = (x) => (_ctx.isValid = x))
            }, null, 8, ["account", "config"]),
            (_ctx.isPaymentRequestAllowed)
              ? (_openBlock(), _createBlock(_component_RecurrenceOptions, {
                  key: 0,
                  enabled: _ctx.isRecurrenceEnabled,
                  "onUpdate:enabled": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isRecurrenceEnabled) = $event)),
                  interval: _ctx.recurringInterval,
                  "onUpdate:interval": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.recurringInterval) = $event)),
                  ruleType: _ctx.recurringRuleType,
                  "onUpdate:ruleType": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.recurringRuleType) = $event)),
                  startDate: _ctx.dateStart,
                  "onUpdate:startDate": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dateStart) = $event)),
                  endDate: _ctx.dateEnd,
                  "onUpdate:endDate": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dateEnd) = $event)),
                  label: _ctx.$gettext('Set up a recurring request')
                }, null, 8, ["enabled", "interval", "ruleType", "startDate", "endDate", "label"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("footer", _hoisted_7, [
            (!_ctx.isRecurrenceEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    disabled: !_ctx.isValid,
                    class: "button custom-button-modal has-text-weight-medium",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openQrCode()))
                  }, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_fa_icon, { icon: "qrcode" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("QR code")), 1)
                  ], 8, _hoisted_8),
                  (_ctx.isPaymentRequestAllowed)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: !_ctx.isValid,
                        class: "button custom-button-modal has-text-weight-medium",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$modal.next()))
                      }, [
                        _createElementVNode("span", _hoisted_11, [
                          _createVNode(_component_fa_icon, { icon: "plus-circle" })
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Generate request")), 1)
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ], 64))
              : (_ctx.isPaymentRequestAllowed)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    disabled: !_ctx.isRecurrenceReady,
                    class: "button custom-button-modal has-text-weight-medium",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$modal.next()))
                  }, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_fa_icon, { icon: "sync" })
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Create recurrence payment")), 1)
                  ], 8, _hoisted_12))
                : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$modal.step.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("header", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createElementVNode("a", {
                class: "mr-3 is-flex",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$modal.back()))
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_fa_icon, {
                    icon: "arrow-left",
                    class: "fa-lg"
                  })
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$gettext("Request money")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createVNode(_component_RecipientSelector, {
            currency: _ctx.selectedBackend,
            showQrCode: false,
            onClickRecipient: _ctx.handleSelectSender
          }, null, 8, ["currency", "onClickRecipient"]),
          _hoisted_19
        ]))
      : _createCommentVNode("", true),
    (_ctx.$modal.step.value == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("header", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, [
              _createElementVNode("a", {
                class: "mr-3 is-flex",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$modal.back()))
              }, [
                _createElementVNode("span", _hoisted_23, [
                  _createVNode(_component_fa_icon, {
                    icon: "arrow-left",
                    class: "fa-lg"
                  })
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$gettext("Request money")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_fa_icon, {
                  icon: "file-alt",
                  class: "status-icon draft"
                })
              ]),
              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$gettext("Draft")), 1),
              _createElementVNode("p", _hoisted_29, [
                _createTextVNode(_toDisplayString(_ctx.numericFormat(parseFloat(_ctx.form.amount))) + " ", 1),
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.currency), 1)
              ]),
              (_ctx.form.recipientMemo)
                ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.form.recipientMemo), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$gettext("from")), 1),
                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.selectedSender?.name), 1),
                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$gettext("to")), 1),
                _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.userProfile.name), 1)
              ])
            ])
          ]),
          _createElementVNode("footer", _hoisted_37, [
            _createElementVNode("button", {
              class: "button custom-button-modal button-modal has-text-weight-medium action",
              disabled: _ctx.isCreating,
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createPaymentRequest()))
            }, [
              _createElementVNode("span", _hoisted_39, [
                _createVNode(_component_fa_icon, { icon: "check" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Create request")), 1)
            ], 8, _hoisted_38)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}